/* ============================================================
   DOGS SUPREME · ds-steuer-suche.js
   Ortssuche über alle 2.943 deutschen Gemeinden ab 5.000 Einwohnern
   (86 % der Bevölkerung). Quelle: Destatis GV-ISys, Gebietsstand 30.06.2026.

   WARUM EIGENE DATEI: Der Index ist ~156 KB und wird erst beim ersten Fokus
   aufs Suchfeld geladen. Die Mehrheit der Artikel-Leser tippt nie, die soll
   das nicht kosten. Die Rechenlogik (ds-steuer-rechner.js) bleibt schlank.

   RANGFOLGE (in dieser Reihenfolge, innerhalb jeder Stufe nach Einwohnern):
     1. exakter Name          "mannheim" -> Mannheim
     2. Präfix am Namen       "mann"     -> Mannheim
     3. Präfix an einem Wort  "main"     -> Frankfurt am Main
     4. PLZ-Präfix            "68159"    -> Mannheim
     5. Fuzzy (Tippfehler)    "manheim"  -> Mannheim
   Einwohner als Sortierschlüssel ist der Punkt: "mün" muss München zeigen,
   nicht Münchsmünster. Wer die kleine Gemeinde sucht, tippt weiter.

   Kompatibilität wie ds-tm-rechner.js: ES2015, keine #-Felder,
   kein Optional-Chaining, var + function.
   ============================================================ */
(function () {
  'use strict';

  var MAX_TREFFER = 8;
  var MIN_ZEICHEN = 2;
  var FUZZY_AB = 4;        // Fuzzy erst ab 4 Zeichen, sonst matcht alles
  var FUZZY_MAX_DIST = 1;  // ein Tippfehler. Bei 2 wird es Kaffeesatz.

  /* Faltet BEIDE Umlaut-Wege: ä->ae UND ä->a. Ohne das findet weder
     "muenchen" noch "munchen" die Stadt München. */
  function norm(s) {
    if (typeof s !== 'string') return '';
    var t = s.toLowerCase().trim();
    t = t.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss');
    t = t.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    return t.replace(/[^a-z0-9]/g, '');
  }

  /* Wörter eines Namens, einzeln normalisiert: "Frankfurt am Main"
     -> ["frankfurt","am","main"]. Damit findet "main" die Stadt. */
  function woerter(name) {
    return name.split(/[\s\-\/(),.]+/).map(norm).filter(function (w) { return w.length > 1; });
  }

  /* Damerau-Levenshtein, NICHT einfaches Levenshtein.
     Der Grund ist der häufigste Tippfehler überhaupt: der Buchstabendreher.
     "münchne" statt "münchen" ist in Levenshtein Distanz 2 (löschen + einfügen)
     und fiele bei max=1 durch. Damerau zählt die Transposition als EINE
     Operation, damit greift der Toleranzrahmen dort, wo Menschen wirklich
     danebentippen. Mit früher Abbruchkante: über 2.943 Orte bei jedem
     Tastendruck voll auszurechnen wäre Verschwendung. */
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var la = a.length, lb = b.length, i, j;
    if (!la) return lb;
    if (!lb) return la;
    var d = [];
    for (i = 0; i <= la; i++) { d[i] = []; d[i][0] = i; }
    for (j = 0; j <= lb; j++) d[0][j] = j;
    for (i = 1; i <= la; i++) {
      var best = Infinity;
      for (j = 1; j <= lb; j++) {
        var kost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + kost);
        /* Transposition: "ne" <-> "en" kostet 1, nicht 2 */
        if (i > 1 && j > 1 &&
            a.charAt(i - 1) === b.charAt(j - 2) &&
            a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, d[i - 2][j - 2] + 1);
        }
        d[i][j] = v;
        if (v < best) best = v;
      }
      if (best > max) return max + 1;
    }
    return d[la][lb];
  }

  /* Packt das Kompaktformat aus. Der Index kommt als Arrays plus
     deduplizierten Kreis-/BL-Listen, sonst wäre er doppelt so groß. */
  function expand(idx) {
    var f = idx.felder;
    var iAgs = f.indexOf('ags'), iName = f.indexOf('name'), iBl = f.indexOf('bl');
    var iEw = f.indexOf('ew'), iPlz = f.indexOf('plz'), iKreis = f.indexOf('kreis');
    var iZus = f.indexOf('zusatz');
    var out = [];
    for (var i = 0; i < idx.orte.length; i++) {
      var r = idx.orte[i];
      var name = r[iName];
      out.push({
        ags: r[iAgs],
        name: name,
        bl: idx.bl[r[iBl]],
        ew: r[iEw],
        plz: r[iPlz],
        kreis: r[iKreis] >= 0 ? idx.kreise[r[iKreis]] : '',
        zusatz: r[iZus] || '',
        _s: norm(name),
        _w: woerter(name)
      });
    }
    return out;
  }

  /* Bundesland-Namen -> BL-Kuerzel. Ohne das tippt jemand "Hessen" und bekommt
     nur die Orte, deren AMTLICHER Name zufaellig "(Hessen)" traegt (Langen, Friedberg
     als Disambiguierung), aber NICHT Frankfurt ("Frankfurt am Main", kein Hessen-Wort).
     Das ist verwirrend und war ein echter Bug. Die Hundesteuer legt zwar jede Gemeinde
     selbst fest, aber Menschen tippen Bundeslaender, also fangen wir das ab und zeigen
     die groessten Staedte des Landes. norm() faltet Umlaute (ue/ü->u), daher hier schon
     gefaltet. Nur volle Namen plus "nrw": 2-Buchstaben-Kuerzel wuerden die normale
     Praefixsuche kapern ("be" ist Bergisch, nicht Berlin-das-Land). */
  var BL_NAMEN = {
    badenwurttemberg: 'BW', bayern: 'BY', freistaatbayern: 'BY', berlin: 'BE',
    brandenburg: 'BB', bremen: 'HB', hamburg: 'HH', hessen: 'HE',
    mecklenburgvorpommern: 'MV', mecklenburg: 'MV', niedersachsen: 'NI',
    nordrheinwestfalen: 'NW', nrw: 'NW', rheinlandpfalz: 'RP', saarland: 'SL',
    sachsen: 'SN', sachsenanhalt: 'ST', schleswigholstein: 'SH', thuringen: 'TH'
  };
  var BL_VOLL = {
    BW: 'Baden-Württemberg', BY: 'Bayern', BE: 'Berlin', BB: 'Brandenburg',
    HB: 'Bremen', HH: 'Hamburg', HE: 'Hessen', MV: 'Mecklenburg-Vorpommern',
    NI: 'Niedersachsen', NW: 'Nordrhein-Westfalen', RP: 'Rheinland-Pfalz',
    SL: 'Saarland', SN: 'Sachsen', ST: 'Sachsen-Anhalt',
    SH: 'Schleswig-Holstein', TH: 'Thüringen'
  };

  function suche(orte, q) {
    var n = norm(q);
    var roh = (q || '').trim();
    if (n.length < MIN_ZEICHEN && !/^\d{2,}$/.test(roh)) return [];

    /* Bundesland getippt: groesste Staedte des Landes, nach Einwohnern. Die Liste
       traegt .blLand, damit das UI erklaeren kann, warum diese Staedte erscheinen. */
    if (BL_NAMEN.hasOwnProperty(n)) {
      var bl = BL_NAMEN[n];
      var imLand = [];
      for (var b = 0; b < orte.length; b++) {
        if (orte[b].bl === bl) imLand.push(orte[b]);
      }
      imLand.sort(function (a, c) { return c.ew - a.ew; });
      var top = imLand.slice(0, MAX_TREFFER);
      top.blLand = BL_VOLL[bl];
      return top;
    }

    var exakt = [], praefix = [], wort = [], plz = [], fuzzy = [];
    var istZahl = /^\d+$/.test(roh);

    for (var i = 0; i < orte.length; i++) {
      var o = orte[i];

      if (istZahl) {
        if (o.plz && o.plz.indexOf(roh) === 0) plz.push(o);
        continue;
      }
      if (o._s === n) { exakt.push(o); continue; }
      if (o._s.indexOf(n) === 0) { praefix.push(o); continue; }

      var w = false;
      for (var j = 1; j < o._w.length; j++) {
        if (o._w[j].indexOf(n) === 0) { w = true; break; }
      }
      if (w) { wort.push(o); continue; }

      /* Fuzzy nur, wenn die exakten Stufen wenig liefern. Sonst drängt sich
         bei "ber" halb Deutschland vor Berlin.

         DREI Vergleiche, weil Menschen auf drei Arten danebentippen, und der
         Präfix muss mitwandern, sonst reisst die Vorschlagsliste mitten im
         Tippen ab:
           a) gleich lang:  "mannhaim" vs "mannheim"  (Buchstabe vertauscht)
           b) einer fehlt:  "manhe"    vs "mannhe"     (Präfix +1)
           c) einer zu viel:"mannnh"   vs "mannh"      (Präfix -1)

         WICHTIG: Der erste Buchstabe muss stimmen. Ohne diese Bedingung
         findet "mann" auch Hannover (dist 1: m->h) und Mainz. Das ist
         technisch korrekt und trotzdem Unsinn: niemand tippt "mann" und
         meint Hannover. */
      if (n.length >= FUZZY_AB &&
          exakt.length + praefix.length + wort.length < MAX_TREFFER &&
          o._s.charAt(0) === n.charAt(0)) {
        var kandidaten = [
          o._s.slice(0, n.length),
          o._s.slice(0, n.length + 1),
          o._s.slice(0, Math.max(1, n.length - 1))
        ];
        for (var c = 0; c < kandidaten.length; c++) {
          if (dist(n, kandidaten[c], FUZZY_MAX_DIST) <= FUZZY_MAX_DIST) {
            fuzzy.push(o);
            break;
          }
        }
      }
    }

    function nachEw(a, b) { return b.ew - a.ew; }
    exakt.sort(nachEw); praefix.sort(nachEw); wort.sort(nachEw);
    plz.sort(nachEw); fuzzy.sort(nachEw);

    return exakt.concat(praefix, wort, plz, fuzzy).slice(0, MAX_TREFFER);
  }

  /* Für den Fallback: wie viele Nachbarn im selben Kreis sind erfasst?
     Der Kreis erhebt KEINE Hundesteuer (das macht die Gemeinde), er dient
     nur der Einordnung und dem Weg zur richtigen Satzung. */
  function kreisKontext(orte, ort, erfassteAgs) {
    if (!ort.kreis) return null;
    var geschwister = [], erfasst = [];
    for (var i = 0; i < orte.length; i++) {
      if (orte[i].kreis === ort.kreis && orte[i].ags !== ort.ags) {
        geschwister.push(orte[i]);
        if (erfassteAgs.indexOf(orte[i].ags) > -1) erfasst.push(orte[i]);
      }
    }
    return { kreis: ort.kreis, geschwister: geschwister.length, erfasst: erfasst };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      norm: norm, woerter: woerter, dist: dist,
      expand: expand, suche: suche, kreisKontext: kreisKontext
    };
    return;
  }

  window.DS_STEUER_SUCHE = {
    norm: norm, expand: expand, suche: suche, kreisKontext: kreisKontext
  };
})();
